import React from "react";

import { Button } from "../../../shared/inputs";

const IntroScreen = (props) => {

    return (
        <div className="intro-screen">
            <div className="intro-screen-text">
                {props.name}: <div className="intro-screen-text-title"> {props.subtitle}</div>
            </div>
            <div className="intro-screen-body">
                <div className="intro-screen-body-text">
                    <div className="text-wrapper" >
                        <p className="mb-0">
                            {props.description}
                        </p>
                    </div>
                    <Button className="px-5 intro-btn" onClick={() => props.onClose(false)}>{props.buttonLabel}</Button>
                </div>
            </div>
        </div>
    );
};

export default IntroScreen;
